import { ContentActions, ContentActionTypes } from '../actions/content.actions';

export interface ContentState {
  disableMargin: boolean;
}

export const contentInitialState: ContentState = {
  disableMargin: false,
};

export function contentReducer(
  state = contentInitialState,
  action: ContentActions,
): ContentState {
  switch (action.type) {
    case ContentActionTypes.DisableMargin:
      return { ...state, disableMargin: true };

    case ContentActionTypes.EnableMargin:
      return { ...state, disableMargin: false };

    default:
      return state;
  }
}
